import React from 'react';
import Icon from '../Icons/Icon';
import { classNames } from '../../Services/helpers';
import Text from '../Formatting/Text';

const NoItems = ({title, message, icon = null, onClick, className, short, shorter, disabled}) => {
    return <button
        type="button"
        disabled={disabled}
        className={classNames(
            shorter ? 'py-2' : (short ? 'py-4' : 'py-8 my-4'),
            shorter ? 'border' : 'border-2',
            'surface-1 relative block w-full rounded-lg border-dashed border-muted text-center',
            className
        )}
        onClick={onClick}
    >
        {(icon && !shorter) && <Icon icon={icon} size={short ? '2x' : '3x'} inline />}

        <span className="mt-2 mx-auto block text-sm font-semibold max-w-[75%]">
            {shorter && <Icon icon={icon} className="mr-4" inline />}
            {title}
        </span>

        <span className="mt-2 mx-auto block text-sm max-w-[75%] text-pretty">
            <Text>{message}</Text>
        </span>
    </button>
}

export default NoItems;
